export const makeProfileImg = (seed) => {
  return `https://api.dicebear.com/7.x/initials/svg?seed=${seed}`
}
